
import React from 'react';
import { Clock } from "lucide-react";

interface Period {
  startTime: string;
  endTime: string;
}

interface TimeSlotsListProps {
  periods: Period[];
}

const TimeSlotsList: React.FC<TimeSlotsListProps> = ({ periods }) => {
  return (
    <div>
      <h3 className="font-medium mb-3">Slots Disponíveis</h3>
      <div className="max-h-48 overflow-y-auto space-y-2">
        {periods.map((period, periodIndex) => {
          const slots = [];
          const start = period.startTime.substring(0, 5);
          const end = period.endTime.substring(0, 5);
          const [startHour, startMin] = start.split(':').map(Number);
          const [endHour, endMin] = end.split(':').map(Number);
          const startMinutes = startHour * 60 + startMin;
          const endMinutes = endHour * 60 + endMin;
          
          for (let minutes = startMinutes; minutes < endMinutes; minutes += 30) {
            const slotHour = Math.floor(minutes / 60);
            const slotMin = minutes % 60;
            const nextHour = Math.floor((minutes + 30) / 60);
            const nextMin = (minutes + 30) % 60;
            
            const slotStart = `${slotHour.toString().padStart(2, '0')}:${slotMin.toString().padStart(2, '0')}`;
            const slotEnd = `${nextHour.toString().padStart(2, '0')}:${nextMin.toString().padStart(2, '0')}`;
            
            slots.push(
              <div key={`${periodIndex}-${slotStart}`} className="flex items-center gap-2 text-sm">
                <Clock className="h-3 w-3 text-muted-foreground" />
                <span>{slotStart} - {slotEnd}</span>
              </div>
            );
          }
          
          return slots;
        })}
      </div>
    </div>
  );
};

export default TimeSlotsList;
